import { render, staticRenderFns } from "./WarningNotification.vue?vue&type=template&id=81e366c4&scoped=true&"
import script from "./WarningNotification.vue?vue&type=script&lang=js&"
export * from "./WarningNotification.vue?vue&type=script&lang=js&"
import style0 from "./WarningNotification.vue?vue&type=style&index=0&id=81e366c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e366c4",
  null
  
)

export default component.exports